// following https://gist.github.com/fernandohu/122e88c3bcd210bbe41c608c36306db9
import { Injectable } from '@angular/core'
import { Http, RequestOptions } from '@angular/http'
import { config } from '../config/config'

@Injectable()
export class StartupService {
  public userData = {}
  private options = new RequestOptions({ withCredentials: true })

  constructor (private http: Http) {}

  async init (): Promise<any> {
    try {
      const result = await this.http.get(`${config.api.url}/api/users/me`, this.options).toPromise()
      this.userData = result.json()
    } catch (e) {
      this.userData = {}
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/startup.service.ts